var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:[_vm.secondary ? 'secondary' : 'primary', _vm.disabled && 'disabled', _vm.back && 'back'],on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }